interface NormalizedError {
    truncatedErrorMessage: string;
    fullErrorMessage: string;
}

const TRUNCATED_ERROR_LENGTH = 90;
export function normalizeBlockchainError(error: Error): NormalizedError {
    let finalError: Error;
    try {
        finalError = JSON.parse(error.message);
    } catch (e) {
        finalError = error;
    }

    console.error("finalError", finalError);

    const fullLengthErrorMessage = (finalError && finalError.message) || finalError.toString();
    const finalErrorMessage = `${`${fullLengthErrorMessage}`.slice(0, TRUNCATED_ERROR_LENGTH)}${
        fullLengthErrorMessage.length > TRUNCATED_ERROR_LENGTH ? "..." : ""
    }`;

    return {
        truncatedErrorMessage: finalErrorMessage,
        fullErrorMessage: fullLengthErrorMessage,
    };
}
